(() => {
  if (!window.ResizeObserver) return;

  const VARIANT_CLASS = 'pdp-ab-variant';
  const MAX_WAIT_MS = 5000;

  function syncThumbnailHeight() {
    document.querySelectorAll('product-gallery.product-gallery--desktop-thumbnails-left').forEach((gallery) => {
      const arWrapper = gallery.querySelector('.product-gallery__ar-wrapper');
      const thumbnailList = gallery.querySelector('.product-gallery__thumbnail-list');

      if (!arWrapper || !thumbnailList) return;

      const desktopQuery = window.matchMedia('(min-width: 1150px)');

      const syncHeight = () => {
        thumbnailList.style.height = desktopQuery.matches ? `${arWrapper.offsetHeight}px` : '';
      };

      new ResizeObserver(syncHeight).observe(arWrapper);
      desktopQuery.addEventListener('change', syncHeight);
    });
  }

  if (document.documentElement.classList.contains(VARIANT_CLASS)) {
    syncThumbnailHeight();
    return;
  }

  // Intelligems adds the variant class to <html> async after page load, so wait for it instead of assuming a fixed delay.
  const observer = new MutationObserver(() => {
    if (document.documentElement.classList.contains(VARIANT_CLASS)) {
      observer.disconnect();
      syncThumbnailHeight();
    }
  });

  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  setTimeout(() => observer.disconnect(), MAX_WAIT_MS);
})();
